import React, { useEffect, useState } from 'react'
import { Divider, Form, Switch } from 'antd'
import UpdatedTicketCategory from '../../UpdatedTicketCategory'
import TooltipInfo from '../../../../../CreateEventV2/TooltipInfo'

const { Item, List } = Form
const RaffleCategory = ({ currentEventDetails }) => {
  const [raffleSwitch, setRaffleSwitch] = useState(false)
  const donationTicketHandler = () => {
    setRaffleSwitch(!raffleSwitch)
  }
  useEffect(() => {
    setRaffleSwitch(!!currentEventDetails?.raffle?.length)
  }, [currentEventDetails])

  const tooltipTitle = (
    <>
      Charity Raffle events require a deposit. You will be prompted to pay upon making the Tickets.
      <br /><br />
      Note: The Promoter must follow the charity rules of their jurisdiction of sale location
    </>
  )

  const additionalTooltip = (
    <TooltipInfo
      className='tooltipTitle'
      text='Additional fees apply'
      info={tooltipTitle}
    />
  )

  return (
    <div className='typeCategoryWrapper'>
      <div className='wrapperTitleRadioText'>
        <div className='titleWrapper'>
          <div className='title'>Charity Raffle</div>
          <div className='tooltipWrapper'>{additionalTooltip}</div>
        </div>
        <div className='radioItem'>
          <Item style={{ marginBottom: 0 }} name='raffleSwitch' valuePropName='checked' className='item'>
            <Switch onChange={donationTicketHandler} checked={raffleSwitch} />
          </Item>
          <div className='text'>Enable Charity</div>
        </div>
      </div>
      {raffleSwitch &&
        <List name='raffle'>
          {(fields, { add, remove }) => (
            <div className='updatedCategoriesWrapper'>
              {fields.map((field, i) =>
                <div key={field.fieldKey}>
                  <UpdatedTicketCategory
                    categoryType='Raffle'
                    namePrefix={i}
                    fieldKey={field.fieldKey}
                    fieldsLength={fields.length}
                    switchToggleOff={setRaffleSwitch}
                    onRemove={remove}
                  />
                </div>,
              )}
              {fields.length === 0 && (
                <div key='defaultForm'>
                  {/* Render default form when no categories exist */}
                  <UpdatedTicketCategory
                    categoryType='Raffle'
                    namePrefix={0}
                    fieldsLength={fields.length + 1}
                    switchToggleOff={setRaffleSwitch}
                    onRemove={remove}
                  />
                </div>
              )}
              <div
                id='addCategory' className='addCategoryBtn' onClick={() => {
                  add()
                }}
              >Add Another Charity Raffle Category
              </div>
            </div>)}
        </List>}
      <Divider />
    </div>
  )
}

export default RaffleCategory
